import { useParams } from "react-router-dom";
import { getLocalStorageData } from "../../utils/LocalStorageService";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { ACTION_TYPE, REPORT_NAME, REPORT_PATH } from "../constant/reportType";
import { Switch, Table } from "antd";
import { EVENT_MASTER_COLUMN, EVENT_TYPE_COLUMN, SOVEREIGN_EVENT_LEDGER_COLUMN } from "../constant/AppConstant";
import { BsPlus, BsSearch, BsPencilSquare } from "react-icons/bs";
import { alertMessage } from "../../utils/AlertService";
import { useAppSelector } from "../../redux-toolkit/hooks";
import Loading from "../Loading";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

import { useDeleteEventMasterMutation, useGetAllEventMasterMutation } from "../../redux-toolkit/services/eventMasterService";
import { useDeleteEventTypeMutation, useGetAllEventTypeMutation } from "../../redux-toolkit/services/eventTypeService";
import { useDeleteLedgerMutation, useGetAllLedgerMutation } from "../../redux-toolkit/services/sovereignEventLedgerService";
import { getAllEventMasterDetails, getEventMasterTotalRecords, setEventMaster } from "../../redux-toolkit/slices/eventMasterSlice";
import { getAllEventTypeDetails, getEventTypeTotalRecords, setEventType } from "../../redux-toolkit/slices/eventTypeSlice";
import { getAllLedgerDetails, getLedgerTotalRecords, setLedger } from "../../redux-toolkit/slices/sovereignEventLedgerSlice";
import EventData from "./EventData";

type Props = {};
const Events = (props: Props) => {
    const params = useParams();
    const dispatch = useDispatch();
    const localUserObj: any = getLocalStorageData("localUser");

    //state
    const [actionType, setActionType] = useState(ACTION_TYPE.ADD_ACTION) as any;
    const [reportName, setReportName]: any = useState();
    const [currentpage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [show, setShow] = useState(false);
    const [selectedRow, setSelectedRow]: any = useState([]);
    const [columData, setColumnData]: any = useState();
    const [dataSource, setDatasource]: any = useState([]);
    const [call, setCall] = useState("N");

    //getMutations
    const [getAllEventMaster, allEventMasterResponse] = useGetAllEventMasterMutation();
    const [getAllEventType, allEventTypeResponse] = useGetAllEventTypeMutation();
    const [getAllLedger, allLedgerResponse] = useGetAllLedgerMutation();

    //delete mutation
    const [deleteEventMaster, deleteEventMasterResponse] = useDeleteEventMasterMutation();
    const [deleteEventType, deleteEventTypeResponse] = useDeleteEventTypeMutation();
    const [deleteLedger, deleteLedgerResponse] = useDeleteLedgerMutation();

    //totalRecords
    const totalEventMaster: any = useAppSelector(getEventMasterTotalRecords);
    const totalEventType: any = useAppSelector(getEventTypeTotalRecords);
    const totalLedger: any = useAppSelector(getLedgerTotalRecords);

    //selector
    const allEventMaster: any = useAppSelector(getAllEventMasterDetails);
    const allEventType: any = useAppSelector(getAllEventTypeDetails);
    const allLedger: any = useAppSelector(getAllLedgerDetails);

    useEffect(() => {
        switch (params.reportType) {
            case REPORT_PATH.EVENT_MASTER:
                setReportName(REPORT_NAME.EVENT_MASTER)
                break;
            case REPORT_PATH.EVENT_TYPE:
                setReportName(REPORT_NAME.EVENT_TYPE)
                break;
            case REPORT_PATH.SOVEREIGN_EVENT_LEDGER:
                setReportName(REPORT_NAME.SOVEREIGN_EVENT_LEDGER)
                break;
            default:
        }
    }, [params.reportType]);

    useEffect(() => {
        const temp: any = [];
        const tempAction: any = {
            title: "Action",
            dataIndex: "action",
            key: "name",
            fixed: "right",
            width: 150,
            render: (index: any, record: any) => {
                return (
                    <div className="d-flex justify-content-between">
                        <div className="px-2 pe-auto">
                            <Switch
                                className={`${record.status === true ||
                                    record.enabled === true ||
                                    record.isActive === true ? "bg-accent" : "bg-secondry"}`}
                                checked={
                                    record.status === true ||
                                        record.enabled === true ||
                                        record.isActive === true
                                        ? true
                                        : false
                                }
                                onClick={() => {
                                    onDeleteData(record);
                                }}
                            />
                        </div>
                        {record.status === true ||
                            record.enabled === true ||
                            record.isActive === true ? (
                            <div
                                className="px-2 pe-auto cursor-pointer"
                                onClick={() => {
                                    handleOpenForm(record);
                                }}
                            >
                                <BsPencilSquare size={18} />
                            </div>
                        ) : null}
                    </div>
                );
            },
        };

        if (reportName === REPORT_NAME.EVENT_MASTER && EVENT_MASTER_COLUMN) {
            EVENT_MASTER_COLUMN.map((item: any) => temp.push(item));
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.EVENT_TYPE && EVENT_TYPE_COLUMN) {
            EVENT_TYPE_COLUMN.map((item: any) => temp.push(item));
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.SOVEREIGN_EVENT_LEDGER && SOVEREIGN_EVENT_LEDGER_COLUMN) {
            SOVEREIGN_EVENT_LEDGER_COLUMN.map((item: any) => temp.push(item));
            temp.push(tempAction);
            setColumnData(temp);
        }
    }, [reportName, params.reportType]);

    useEffect(() => {
        if (reportName === REPORT_NAME.EVENT_MASTER) {
            getAllEventMaster({
                token: localUserObj?.token,
                page: currentpage - 1,
                size: pageSize,
                sort: "desc",
            });
        } else if (reportName === REPORT_NAME.EVENT_TYPE) {
            getAllEventType({
                token: localUserObj?.token,
                page: currentpage - 1,
                size: pageSize,
                sort: "desc",
            });
        } else if (reportName === REPORT_NAME.SOVEREIGN_EVENT_LEDGER) {
            getAllLedger({
                token: localUserObj?.token,
                page: currentpage - 1,
                size: pageSize,
                sort: "desc",
            });
        }
    }, [reportName]);

    useEffect(() => {
        if (call === "Y") {
            if (reportName === REPORT_NAME.EVENT_MASTER) {
                getAllEventMaster({
                    token: localUserObj?.token,
                    page: currentpage - 1,
                    size: pageSize,
                    sort: "desc",
                });
                setCall("N");
            } else if (reportName === REPORT_NAME.EVENT_TYPE) {
                getAllEventType({
                    token: localUserObj?.token,
                    page: currentpage - 1,
                    size: pageSize,
                    sort: "desc",
                });
                setCall("N");
            } else if (reportName === REPORT_NAME.SOVEREIGN_EVENT_LEDGER) {
                getAllLedger({
                    token: localUserObj?.token,
                    page: currentpage - 1,
                    size: pageSize,
                    sort: "desc",
                });
                setCall("N");
            }
        }
    }, [call]);

    const paginationChange = (page: number, pageSize: number) => {
        if (reportName === REPORT_NAME.EVENT_MASTER) {
            getAllEventMaster({
                token: localUserObj?.token,
                page: page - 1,
                size: pageSize,
                sort: "desc",
            });
        } else if (reportName === REPORT_NAME.EVENT_TYPE) {
            getAllEventType({
                token: localUserObj?.token,
                page: page - 1,
                size: pageSize,
                sort: "desc",
            });
        } else if (reportName === REPORT_NAME.SOVEREIGN_EVENT_LEDGER) {
            getAllLedger({
                token: localUserObj?.token,
                page: page - 1,
                size: pageSize,
                sort: "desc",
            });
        }
        setCurrentPage(page);
        setPageSize(pageSize);
    };

    const handleSearch = (event: any) => {
        const searchTerm = event.target.value;
        // Search functionality not implemented in backend yet
        // Fallback or skip
    };

    const handleShow = () => {
        setActionType(ACTION_TYPE.ADD_ACTION);
        setShow(true)
    };

    const onDeleteData = (record: any) => {
        if (reportName === REPORT_NAME.EVENT_MASTER) {
            deleteEventMaster({ token: localUserObj?.token, id: record.id });
        } else if (reportName === REPORT_NAME.EVENT_TYPE) {
            deleteEventType({ token: localUserObj?.token, id: record.id });
        } else if (reportName === REPORT_NAME.SOVEREIGN_EVENT_LEDGER) {
            deleteLedger({ token: localUserObj?.token, id: record.id });
        }
    };

    useEffect(() => {
        if (deleteEventMasterResponse.isSuccess) {
            alertMessage("Event Master status changed", "success");
            setCall("Y");
        } else if (deleteEventMasterResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deleteEventMasterResponse.isSuccess, deleteEventMasterResponse.isError]);

    useEffect(() => {
        if (deleteEventTypeResponse.isSuccess) {
            alertMessage("Event Type status changed", "success");
            setCall("Y");
        } else if (deleteEventTypeResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deleteEventTypeResponse.isSuccess, deleteEventTypeResponse.isError]);

    useEffect(() => {
        if (deleteLedgerResponse.isSuccess) {
            alertMessage("Ledger status changed", "success");
            setCall("Y");
        } else if (deleteLedgerResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deleteLedgerResponse.isSuccess, deleteLedgerResponse.isError]);


    const handleOpenForm = (record: any) => {
        setActionType(ACTION_TYPE.UPDATE_ACTION);
        setSelectedRow(record);
        setShow(true);
    };

    // Data setting
    useEffect(() => {
        if (allEventMasterResponse.isSuccess) {
            dispatch(setEventMaster(allEventMasterResponse));
        } else if (allEventMasterResponse.isError) {
            alertMessage(allEventMasterResponse.error as any, "error");
        }
    }, [allEventMasterResponse.isSuccess, allEventMasterResponse.isError]);

    useEffect(() => {
        if (allEventTypeResponse.isSuccess) {
            dispatch(setEventType(allEventTypeResponse));
        } else if (allEventTypeResponse.isError) {
            alertMessage(allEventTypeResponse.error as any, "error");
        }
    }, [allEventTypeResponse.isSuccess, allEventTypeResponse.isError]);

    useEffect(() => {
        if (allLedgerResponse.isSuccess) {
            dispatch(setLedger(allLedgerResponse as any));
        } else if (allLedgerResponse.isError) {
            alertMessage(allLedgerResponse.error as any, "error");
        }
    }, [allLedgerResponse.isSuccess, allLedgerResponse.isError]);

    useEffect(() => {
        if (allEventMaster && reportName === REPORT_NAME.EVENT_MASTER) {
            setDatasource(allEventMaster);
        }
    }, [allEventMaster]);

    useEffect(() => {
        if (allEventType && reportName === REPORT_NAME.EVENT_TYPE) {
            setDatasource(allEventType);
        }
    }, [allEventType]);

    useEffect(() => {
        if (allLedger && reportName === REPORT_NAME.SOVEREIGN_EVENT_LEDGER) {
            setDatasource(allLedger);
        }
    }, [allLedger]);

    return (
        <div className="mt-2 overflow-y-auto">
            <div className="d-flex align-items-center justify-content-between flex-sm-row flex-column mb-2">
                <div className="d-flex align-items-center w-100 px-2">
                    <h5
                        className="m-0 px-0 d-flex align-items-center text-accent"
                        style={{ fontWeight: "700" }}
                    >
                        {reportName}
                    </h5>
                </div>
                <div className="d-flex align-items-center justify-content-start justify-content-sm-end cursor-pointer w-100 flex-wrap" style={{ gap: '8px' }}>
                    <div className="d-flex flex-column" style={{ minWidth: "200px" }}>
                        <div className="input-group px-2 mt-1">
                            <Form.Control
                                type="search"
                                placeholder="Search"
                                className="border-0 bg-cm-light-primary1"
                                aria-label="Search"
                                onChange={handleSearch}
                            />
                            <div className="input-group-append bg-cm-light-primary1 p-1 rounded-end">
                                <span className="input-group-text bg-cm-light-primary1 border-0">
                                    <BsSearch className=" bg-cm-light-primary1 border-cm-light-primary1" />
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="d-flex px-2 align-items-center mt-1">
                        <Button
                            className="d-flex align-items-center me-0 text-nowrap bg-accent border-0"
                            onClick={handleShow}
                        >
                            <BsPlus />
                            Add
                        </Button>
                    </div>
                    {allEventMasterResponse.isLoading || deleteEventMasterResponse.isLoading || allEventTypeResponse.isLoading || deleteEventTypeResponse.isLoading || allLedgerResponse.isLoading || deleteLedgerResponse.isLoading
                        ? (
                            <Loading />
                        ) : (
                            ""
                        )}
                    {show && (
                        <EventData
                            show={show}
                            setShow={setShow}
                            actionType={actionType}
                            reportName={reportName}
                            data={selectedRow}
                            setCall={setCall}
                        />
                    )}
                </div>
            </div>

            <div className="mt-3 my-2 w-100 overflow-x-auto rounded-3">
                <Table
                    bordered={true}
                    rowKey={"id"}
                    scroll={{ x: 'max-content' }}
                    tableLayout="fixed"
                    pagination={{
                        total: reportName === REPORT_NAME.EVENT_MASTER ? totalEventMaster : reportName === REPORT_NAME.EVENT_TYPE ? totalEventType : totalLedger,
                        responsive: true,
                        current: currentpage,
                        pageSizeOptions: [10, 20, 30],
                        onChange: (page, pageSize) => {
                            paginationChange(page, pageSize);
                        },
                        pageSize: pageSize,
                    }}
                    columns={columData}
                    dataSource={dataSource}
                />
            </div>
        </div>
    );
};

export default Events;
